export const VehicleApiVersion = 'v2';
export const ReepayApiVersion = 'v1';
